module.exports = __webpack_public_path__ + "static/media/giphy.bd4631d3.gif";